import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel } from 'swiper/modules';
import styles from './Components/CSS/AdventureAudioSeries.module.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useNavigate } from 'react-router-dom';
import Loading from '../common/HousGlass Loader/Loading';

const AudioBanner = ({ series, loading }) => {
  const navigate = useNavigate();
  
  if (loading) {
    return <div className={styles.loading}><Loading/></div>;
  }

  // Determine whether to show the "View all" button
  const showViewAll = series.length >= 5;

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentBox}>
        <div className={styles.header}>
          <h2>Audio Series</h2>
          {showViewAll && (
            <button onClick={() => navigate('/audio-series/view-all')} className={styles.viewAllButton}>
              View all &gt;
            </button>
          )}
        </div>
        
        <div className={styles.carouselContainer}>
          <Swiper
            modules={[Navigation, Mousewheel]}
            navigation
            mousewheel={{ forceToAxis: true, invert: false }}
            spaceBetween={20}
            slidesPerView={2}
            breakpoints={{
              320: { slidesPerView: 1.5, spaceBetween: 10 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1024: { slidesPerView: 2, spaceBetween: 20 },
              1200: { slidesPerView: 3, spaceBetween: 20 },
            }}
            className={styles.swiper}
          >
            {series.map((item) => (
              <SwiperSlide key={item.id}>
                <div className={styles.cardWrapper} onClick={() => navigate(`/audio-play/${item.slug}`)}>
                  <div className={styles.imageContainer}>
                    <div
                      className={styles.backgroundImage}
                      style={{ backgroundImage: `url(${item.coverImageUrl})` }}
                    />
                    <div className={styles.overlay} />
                  </div>
                  <div className={styles.content}>
                    <h3 className={styles.title}>{item.title}</h3>
                    <div className={styles.metadata}>
                      <span className={styles.audioType}>{item.seriesType}</span>
                      <span className={styles.separator}>|</span>
                      <span className={styles.genre}>{item.category?.name || 'Various'}</span>
                      {item.isPremium && (
                        <>
                          <span className={styles.separator}>|</span>
                          <span className={styles.premium}>Premium</span>
                        </>
                      )}
                    </div>
                    <button className={styles.listenButton}>
                      <span className={styles.playIcon}>▶</span> Listen Now
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default AudioBanner;